module.exports = __webpack_public_path__ + "img/02k_marketing.61f46edb.jpg";